import { Parser } from 'json2csv';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import { Button } from 'reactstrap';

import Toaster from 'components/Toaster';
import Issued from 'components/redemption/Issued';
import RedeemModal from 'components/redemption/RedeemModal';
import EmailExportBanner from 'components/Banners/emailExportBanner';

import RewardApi from '../apis/RewardApi';

import { downloadCSV } from 'utils/file';
import UpgradeSubscription from '../components/subscriptionFeature/upgradeSubscription';
import { isBasicPlan, canExportEmails } from '../utils/plansHelper';

class Redemption extends Component {
  constructor(props) {
    super(props);
    this.state = {
      rewards: [],
      modalToggle: false,
      reward: {
        user: {
          first_name: '',
          last_name: '',
          email: '',
        },
      },
      search: '',
      csvData: [{}],
      isUpgradeModalVisible: false,
    };

    this.headers = [
      { label: 'Email Address', value: 'email' },
      { label: 'First Name', value: 'firstname' },
      { label: 'Last Name', value: 'lastname' },
      { label: 'Notes', value: 'notes' },
    ];
  }

  componentWillMount() {
    this.fetchAllReward();
  }

  handleChange = e => {
    const { reward } = this.state;
    const { survey_user } = reward;

    survey_user[e.target.name] = e.target.value;
    reward[survey_user] = survey_user;
    this.setState({ reward });
  };

  fetchIssuedReward = () => {
    const { businessId } = this.props;

    RewardApi.getAllIssued(businessId)
      .then(({ data }) => {
        this.setState({ issued: data });
      })
      .catch(e => console.log(e));
  };

  fetchAllReward = () => {
    const { businessId } = this.props;

    RewardApi.getAll(businessId)
      .then(({ data }) => {
        this.setState({ rewards: data });
        this.fetchEmails();
      })
      .catch(e => console.log(e));
  };

  confirmRedeem = (rewardId, user) => {
    RewardApi.redeemCoupon(rewardId, user)
      .then(({ data }) => {
        Toaster.getSuccessToaster('check-circle', 'Successfully redeemed');
        this.toggleModal();
        this.fetchAllReward();
      })
      .catch(error => {
        Toaster.getFailureToaster(
          error,
          'exclamation-triangle',
          'Email has already been taken'
        );
      });
  };

  modalToggle = reward => {
    this.setState({ modalToggle: true, reward });
  };

  toggleModal = () => {
    this.setState({ modalToggle: false });
  };

  closeModal = e => {
    e.preventDefault();
    this.toggleModal();
  };

  fetchEmails = () => {
    const { rewards } = this.state;
    const redemptionData = rewards
      .map(reward => {
        const { custom_survey, user, created_at } = reward;

        return {
          email: user.email,
          firstname: user.first_name,
          lastname: user.last_name,
          notes: `Soono Survey's Contact via ${
            custom_survey.name
          } on ${new Date(created_at)}`,
        };
      })
      .filter(data => data.email);

    this.setState({ csvData: redemptionData });
  };

  createContent = e => {
    e.preventDefault();
    const { csvData } = this.state;
    if (canExportEmails() || isBasicPlan()) {
      const exportsLimit = isBasicPlan() ? 100 : csvData.length;
      const downloadableCSVData = csvData.slice(0, exportsLimit);
      const json2csvParser = new Parser({ fields: this.headers, quote: '' });
      const csv = json2csvParser.parse(downloadableCSVData);

      downloadCSV(csv);
    } else {
      this.toggleUpgradeModal();
    }
  };

  toggleUpgradeModal = () => {
    this.setState(({ isUpgradeModalVisible }) => ({
      isUpgradeModalVisible: !isUpgradeModalVisible,
    }));
  };

  render() {
    const { businessId } = this.props;
    const {
      reward,
      search,
      modalToggle,
      rewards,
      isUpgradeModalVisible,
    } = this.state;

    return (
      <div className="mt-3">
        <UpgradeSubscription
          isUpgradeModalVisible={isUpgradeModalVisible}
          toggleUpgradeModal={this.toggleUpgradeModal}
          type="exportEmails"
        />
        <RedeemModal
          handleChange={this.handleChange}
          modalToggle={modalToggle}
          closeModal={this.closeModal}
          confirmRedeem={this.confirmRedeem}
          reward={reward}
        />
        <div className="row d-flex justify-content-between">
          <div className="pl-3 export-email-col">
            <Button
              color="#cccccc"
              className="export-email-button"
              onClick={this.createContent}
            >
              <FontAwesomeIcon icon="download" />
              <span>Export</span>
            </Button>
          </div>
          <div className="col-md-6 input-group redemption-search-container">
            <input
              className="form-control search-text-box"
              value={search}
              onChange={e => this.setState({ search: e.target.value })}
            />
            <div className="input-group-addon">
              <button className="btn btn-add-new redemption-search-button">
                <FontAwesomeIcon icon="search" />
                Search
              </button>
            </div>
          </div>
          <div className="col-md-12 d-flex mt-3">
            <EmailExportBanner count={rewards.length} />
          </div>
        </div>
        <div className="py-4">
          <Issued
            search={search}
            businessId={businessId}
            modalToggle={this.modalToggle}
            rewards={rewards}
          />
        </div>
      </div>
    );
  }
}

Redemption.propTypes = {
  businessId: PropTypes.string.isRequired,
};

export default withRouter(Redemption);



// WEBPACK FOOTER //
// ./src/containers/Redemption.js